namespace RedBullMOBILE360.BulkSMS {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.BulkSMS.BulkSMSGrid')
    export class BulkSMSGrid extends Serenity.EntityGrid<BulkSMSRow, any> {
        protected getColumnsKey() { return BulkSMSColumns.columnsKey; }
        protected getDialogType() { return BulkSMSDialog; }
        protected getIdProperty() { return BulkSMSRow.idProperty; }
        protected getInsertPermission() { return BulkSMSRow.insertPermission; }
        protected getLocalTextPrefix() { return BulkSMSRow.localTextPrefix; }
        protected getService() { return BulkSMSService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons(): Serenity.ToolButton[] {
            let buttons = super.getButtons();
            //if (!Q.Authorization.userDefinition.IsAdmin)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push({
                title: 'Import List of numbers',
                cssClass: 'import-button',
                onClick: () => {
                    var dialog = new BulkSMSExcelImportDialog();
                    dialog.dialogOpen();

                    dialog.element.one('dialogclose', () => {
                        this.view.populate();
                    });
                }
            });

            buttons.push(Serenity.Extensions.ExcelExportHelper.createToolButton({
                title: 'Download Template',
                grid: this,
                service: BulkSMSService.baseUrl + '/DownloadTemplate',
                onViewSubmit: () => this.onViewSubmit()
            }));

            return buttons;
        }

        protected getColumns() {
            var columns = super.getColumns();

            if (Q.Authorization.hasPermission("BulkSMS:CancelSMS")) {
                columns.push({
                    field: 'Id',
                    name: '',
                    width: 200,
                    format: ctx => {
                        if (ctx.item.SmsStatus === 0 || ctx.item.SmsStatus === 1) {
                            return `
                        <form action="/BulkSMS/CancelSMS/" method="get">
                            <div class="d-flex align-items-center gap-2 me-5">
                                <input class="d-none" name="SmsId" value="` + ctx.value + `" type="text">
                                <button class="text-danger p-0 btn fw-bold" type="submit" data-bs-toggle="tooltip" data-bs-placement="top" title="Cancel SMS">
                                    Cancel SMS
                                </button>
                            </div>
                        </form>`;
                        } else {
                            return '';
                        }
                    }
                });
            }

            return columns;
        }



    }
}